import React from "react";
import ActionsPopup from "../ActionsPopup";
import schema from "../ActionsPopup/foreign_labor_actions";
import cellGenerator from "./columnUtils";

const foreign_labor_columns = (isSubaccount) => [
  {
    Header: "Profile Name",
    accessor: "RecruiterFormData.new_profile_fl_recr_profile_name",
    Cell: (props) => cellGenerator(props),
    minWidth: 200,
    maxWidth: 250,
  },
  {
    Header: "Last Name",
    accessor: "RecruiterFormData.new_profile_fl_recr_last_name",
    Cell: (props) => cellGenerator(props),
  },
  {
    Header: "First Name",
    accessor: "RecruiterFormData.new_profile_fl_recr_first_name",
    Cell: (props) => cellGenerator(props),
  },
  {
    Header: "Organization",
    accessor: "RecruiterFormData.new_profile_fl_recr_employer_name",
    Cell: (props) => cellGenerator(props),
    minWidth: 250,
  },
  {
    Header: "Country",
    accessor: "RecruiterFormData.new_profile_fl_recr_country_id",
    Cell: (props) => cellGenerator(props),
    minWidth: 260,
    maxWidth: 270,
  },
  {
    id: "actions",
    Header: "Actions",
    accessor: (d) => d,
    fixedWidth: 130,
    disableSortBy: true,
    isButton: true, // removes padding and positioning
    Cell: ({ row: { original } }) => (
      <ActionsPopup
        actionsPopupSchema={schema("foreign-labor", isSubaccount)}
        id={original.id}
      />
    ),
  },
];

export default foreign_labor_columns;
